import { render, staticRenderFns } from "./VehicleTypeEditDashboard.vue?vue&type=template&id=9d5154d2&"
import script from "./VehicleTypeEditDashboard.vue?vue&type=script&lang=ts&"
export * from "./VehicleTypeEditDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports